<body class="edi-swap">
  <app-table-header
    [headerText]="CONSTANTS.HEADER_TEXT"
    [rightPadding]="10"
    [hasDeleteIcon]="true"
    [hasEditIcon]="true"
    [hasFileDownload]="true"
    [hasFilter]="false"
    [hasFileUpload]="true"
    [editIconDisabled]="!selectedEdi"
    [deleteDisabled]="!selectedEdi"
    [fileDownloadText]="CONSTANTS.SWAP_TEMPLATE"
    [fileUploadText]="CONSTANTS.SWAP_UPLOAD"
    (exportExcelEvent)="exportExcel()"
    (addItemEvent)="addEdi()"
    (editEvent)="editEdi()"
    (deleteEvent)="deleteEdi()"
    (fileUploadEvent)="uploadSwap()"
    (fileDownloadEvent)="saveTemplate()"
  ></app-table-header>

  <!-- table -->
  <div class="edi-swap-table-container">
    <table mat-table class="edi-swap-table" [dataSource]="dataSource">
      <caption>
        EDI Swap
      </caption>

      <!-- Radio Button Column -->
      <ng-container matColumnDef="select">
        <th class="th-text" mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let edi">
          <mat-radio-group [(ngModel)]="selectedEdi" name="ediSelection">
            <mat-radio-button [value]="edi"></mat-radio-button>
          </mat-radio-group>
        </td>
      </ng-container>

      <!-- ID -->
      <ng-container matColumnDef="id">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="id-headers"
          class="id-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.ID"
            [control]="idData.formControl"
            [maxLength]="14"
            [autoCapitalizeCharacters]="true"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="id-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.id }}
        </td>
      </ng-container>

      <!-- Name -->
      <ng-container matColumnDef="name">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="name-headers"
          class="name-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.NAME"
            [control]="nameData.formControl"
            [maxLength]="24"
            [autoCapitalizeCharacters]="true"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="name-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.name }}
        </td>
      </ng-container>

      <!-- Active -->
      <ng-container matColumnDef="active">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="active-headers"
          class="active-headers"
        >
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.ACTIVE"
            [searchResults]="activeDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            [textInputWidth]="60"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (checkboxesUpdated)="onStatusChangeForDropdowns($event, activeData)"
          >
          </app-table-header-dropdown>
        </th>

        <td
          headers="active-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.active }}
        </td>
      </ng-container>

      <!-- effective -->
      <ng-container matColumnDef="effective">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="effective-headers"
          class="date-header effective-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.EFFECTIVE"
            [control]="effectiveData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="effective-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.effective }}
        </td>
      </ng-container>

      <!-- expires -->
      <ng-container matColumnDef="expires">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="expires-headers"
          class="date-header expires-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.EXPIRES"
            [control]="expiresData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="expires-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.expires }}
        </td>
      </ng-container>

      <!-- mon -->
      <ng-container matColumnDef="mon">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="mon-headers"
          class="mon-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.MON"
            [data]="monData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[1]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, monData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="mon-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.mon === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- tue -->
      <ng-container matColumnDef="tue">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="tue-headers"
          class="tue-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.TUE"
            [data]="tueData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[2]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 2)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, tueData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="tue-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.tue === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- wed -->
      <ng-container matColumnDef="wed">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="name-headers"
          class="wed-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.WED"
            [data]="wedData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[3]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 3)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, wedData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="wed-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.wed === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- thu -->
      <ng-container matColumnDef="thu">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="thu-headers"
          class="thu-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.THU"
            [data]="thuData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[4]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 4)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, thuData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="thu-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.thu === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- fri -->
      <ng-container matColumnDef="fri">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="fri-headers"
          class="fri-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.FRI"
            [data]="friData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[5]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 5)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, friData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="fri-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.fri === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- sat -->
      <ng-container matColumnDef="sat">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="sat-headers"
          class="sat-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.SAT"
            [data]="satData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[6]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 6)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, satData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="sat-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.sat === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- sun -->
      <ng-container matColumnDef="sun">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="sun-headers"
          class="sun-headers"
        >
          <app-table-dropdown-status
            [header]="COLUMNTEXT.SUN"
            [data]="sunData"
            [resetData]="resetSelectDropdowns"
            [dropdownWidth]="60"
            [showDropdown]="dropdownOpen[7]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 7)
            "
            (emitStatusChange)="onStatusChangeForDropdowns($event, sunData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          headers="sun-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          @if (edi.sun === true) {
            <img [src]="IMAGES.ACTIVE" alt="true" />
          } @else {
            <img alt="false" [src]="IMAGES.CANCEL" />
          }
        </td>
      </ng-container>

      <!-- origCode -->
      <ng-container matColumnDef="origCode">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="origCode-headers"
          class="origCode-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.ORIG_CODE"
            [control]="origCodeData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="origCode-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.origCode }}
        </td>
      </ng-container>

      <!-- origSort -->
      <ng-container matColumnDef="origSort">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="origSort-headers"
          class="origSort-headers"
        >
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.ORIG_SORT"
            [searchResults]="origSortDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[8]"
            [textInputWidth]="60"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 8)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, origSortData)
            "
          >
          </app-table-header-dropdown>
        </th>

        <td
          headers="origSort-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.origSort }}
        </td>
      </ng-container>

      <!-- destSlic -->
      <ng-container matColumnDef="destSlic">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="destSlic-headers"
          class="destSlic-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.DEST_SLIC"
            [control]="destSlicData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="destSlic-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.destSlic }}
        </td>
      </ng-container>

      <!-- destSort -->
      <ng-container matColumnDef="destSort">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="destSort-headers"
          class="destSort-headers"
        >
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.DEST_SORT"
            [searchResults]="destSortDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[9]"
            [textInputWidth]="60"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 9)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, destSortData)
            "
          >
          </app-table-header-dropdown>
        </th>

        <td
          headers="destSort-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.destSort }}
        </td>
      </ng-container>

      <!-- service -->
      <ng-container matColumnDef="service">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="service-headers"
          class="service-headers"
        >
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.SERVICE"
            [searchResults]="serviceDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[10]"
            [textInputWidth]="60"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 10)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, serviceData)
            "
          >
          </app-table-header-dropdown>
        </th>

        <td
          headers="service-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.service }}
        </td>
      </ng-container>

      <!-- swapSlic -->
      <ng-container matColumnDef="swapSlic">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="swapSlic-headers"
          class="swapSlic-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.SWAP_SLIC"
            [control]="swapSlicData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="swapSlic-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.swapSlic }}
        </td>
      </ng-container>

      <!-- swapSort -->
      <ng-container matColumnDef="swapSort">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="swapSort-headers"
          class="swapSort-headers"
        >
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.SWAP_SORT"
            [searchResults]="swapSortDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[11]"
            [textInputWidth]="60"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 11)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, swapSortData)
            "
          >
          </app-table-header-dropdown>
        </th>

        <td
          headers="swapSort-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.swapSort }}
        </td>
      </ng-container>

      <!-- swapService -->
      <ng-container matColumnDef="swapService">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="swapService-headers"
          class="swapService-headers"
        >
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.SWAP_SERVICE"
            [searchResults]="swapServiceDropDown"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[12]"
            [textInputWidth]="76"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 12)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdowns($event, swapServiceData)
            "
          >
          </app-table-header-dropdown>
        </th>

        <td
          headers="swapService-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.swapService }}
        </td>
      </ng-container>

      <!-- swapPkgLocRole -->
      <ng-container matColumnDef="swapPkgLocRole">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="swapPkgLocRole-headers"
          class="swapPkgLocRole-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.SWAP_PKG_LOC_ROLE"
            [control]="swapPkgLocRoleData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="swapPkgLocRole-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.swapPkgLocRole }}
        </td>
      </ng-container>

      <!-- monLcd -->
      <ng-container matColumnDef="monLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="monLcd-headers"
          class="monLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.MON_LCD"
            [control]="monLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="monLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.monLcd }}
        </td>
      </ng-container>

      <!-- tueLcd -->
      <ng-container matColumnDef="tueLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="tueLcd-headers"
          class="tueLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.TUE_LCD"
            [control]="tueLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="tueLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.tueLcd }}
        </td>
      </ng-container>

      <!-- wedLcd -->
      <ng-container matColumnDef="wedLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="wedLcd-headers"
          class="wedLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.WED_LCD"
            [control]="wedLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="wedLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.wedLcd }}
        </td>
      </ng-container>

      <!-- thuLcd -->
      <ng-container matColumnDef="thuLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="thuLcd-headers"
          class="thuLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.THU_LCD"
            [control]="thuLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="thuLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.thuLcd }}
        </td>
      </ng-container>

      <!-- friLcd -->
      <ng-container matColumnDef="friLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="friLcd-headers"
          class="friLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.FRI_LCD"
            [control]="friLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="friLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.friLcd }}
        </td>
      </ng-container>

      <!-- satLcd -->
      <ng-container matColumnDef="satLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="satLcd-headers"
          class="satLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.SAT_LCD"
            [control]="satLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="satLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.satLcd }}
        </td>
      </ng-container>

      <!-- sunLcd -->
      <ng-container matColumnDef="sunLcd">
        <th
          mat-header-cell
          *matHeaderCellDef
          id="sunLcd-headers"
          class="sunLcd-headers"
        >
          <app-table-search-component
            [columnName]="COLUMNTEXT.SUN_LCD"
            [control]="sunLcdData.formControl"
            [maxLength]="10"
            [autoCapitalizeCharacters]="true"
            [allowedSpecialChars]="SPECIAL_CHARS.DATE_NEGATIVE_NUMBER"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="sunLcd-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let edi"
        >
          {{ edi.sunLcd }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="displayedColumns.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
